
function Confirm(props) {
    return (
<div className='elementor-widget-container'>
<h2 className='elementor-heading-title elementor-size-default'>Your appointment is scheduled for {props.date}</h2>
<p>Be on the look out for email or text from us to confirm your appointment.</p>
</div>

); 
  }
  export default Confirm;